import { Grid, useTheme } from "@mui/material";
import { alpha } from "@mui/material/styles";
import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import PendingOutlinedIcon from "@mui/icons-material/PendingOutlined";
import EventAvailableOutlinedIcon from "@mui/icons-material/EventAvailableOutlined";
import StatCard from "../../components/StatCard/StatCard";

const CandidateProfileStats = ({ dashboardData }) => {
  const theme = useTheme();
  const total = dashboardData?.totalCandidates ?? 0;
  const completedInterviews = dashboardData?.candidateInterviewCompletedCount ?? 0;
  const candidateInterviewScheduledCount = dashboardData?.interviewCandidateCount
  ?? 0;

  const cards = [
    {
      id: "total",
      title: "Total Candidates",
      value: total,
      icon: <PeopleAltOutlinedIcon color="primary" sx={{ fontSize: 20 }} />,
      iconBg: alpha(theme.palette.primary.main, 0.12),
    },
    {
      id: "complete",
      title: "Completed Interviews",
      value: completedInterviews,
      icon: <CheckCircleOutlineIcon color="success" sx={{ fontSize: 20 }} />,
      iconBg: alpha(theme.palette.success.main, 0.12),
    },
    // {
    //   id: "pending",
    //   title: "Pending Screening",
    //   value: pendingScreening,
    //   icon: <PendingOutlinedIcon color="warning" sx={{ fontSize: 20 }} />,
    //   iconBg: "#f7e9d9",
    // },
    {
      id: "interview-scheduled",
      title: "Interview Scheduled",
      value: candidateInterviewScheduledCount,
      icon: <EventAvailableOutlinedIcon color="secondary" sx={{ fontSize: 20 }} />,
      iconBg: alpha(theme.palette.secondary.main, 0.12),
    },
  ];

  return (
    <Grid container spacing={3} sx={{ mb: 3 }}>
      {cards.map((c) => (
        <Grid key={c.id} item size={{ xs: 12, sm: 6, md: 4 }}>
          <StatCard title={c.title} value={c.value} icon={c.icon} iconBg={c.iconBg} />
        </Grid>
      ))}
    </Grid>
  );
};

export default CandidateProfileStats;

